/**
 * Landing-page UTM propagation.
 *
 * Social visitors arrive at `/` via tagged links (/go/:slug redirects here);
 * the landing CTAs are static hrefs to /play and would strip the params.
 * This module re-appends the attribution allowlist to every /play link so
 * the game page — which owns consent-gated attribution capture — still sees
 * the original acquisition signal, even in a new tab or with sessionStorage
 * blocked.
 *
 * Allowlist only: room/payment deep-link params and anything unknown never
 * leak into CTA hrefs.
 */
window.MoonfallLandingUtm = (function () {
  var ALLOWED = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'gclid', 'msclkid', 'fbclid', 'ttclid', 'twclid', 'li_fat_id',
  ];

  function decorate(search) {
    var params;
    try {
      params = new URLSearchParams(search || '');
    } catch (e) {
      return;
    }

    var carried = new URLSearchParams();
    ALLOWED.forEach(function (key) {
      var value = params.get(key);
      if (value) carried.set(key, value);
    });
    if (!Array.from(carried.keys()).length) return;

    document.querySelectorAll('a[href]').forEach(function (a) {
      var href = a.getAttribute('href');
      // Exactly /play (optionally with an existing query) — nothing else.
      if (href !== '/play' && href.indexOf('/play?') !== 0) return;
      var target;
      try {
        target = new URL(href, window.location.origin);
      } catch (e) {
        return;
      }
      // Merge only absent allowlisted keys. This is idempotent for every click
      // id as well as utm_* and preserves an attribution value deliberately
      // attached to a specific CTA.
      carried.forEach(function (value, key) {
        if (!target.searchParams.has(key)) target.searchParams.set(key, value);
      });
      a.setAttribute('href', target.pathname + target.search + target.hash);
    });
  }

  // Snapshot the tagged URL at parse time. The attribution module clears these
  // params from the address bar as soon as it has stored the touch, and it
  // loads after this one — so any later pass must decorate from what the
  // visitor actually arrived with rather than from the tidied bar.
  var arrivalSearch = '';
  try {
    arrivalSearch = window.location.search || '';
  } catch (e) { arrivalSearch = ''; }

  function run() {
    try {
      decorate(arrivalSearch);
    } catch (e) { /* attribution is always best-effort */ }
  }

  // landing.html loads this after its complete visual DOM and before env.js.
  // Decorate immediately so a stalled later dependency cannot expose a CTA
  // that drops attribution. The DOMContentLoaded pass is idempotent and also
  // catches any /play link inserted by a future late module.
  run();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  }

  return { decorate: decorate, run: run };
})();
